"use client"

import PropTypes from "prop-types"
import { useLanguage } from "../../../../contexts/LanguageContext"
import { Icons } from "../../../../components/Icons"

const Types = ({ onSwitch }) => {
  const { t } = useLanguage()

  return (
    <div className="toolswitcher">
      <header>
        <button onClick={() => onSwitch("main")} className="btn btn-secondary flex items-right space-x-2">
          <Icons.ArrowLeft className="w-4 h-4" />{t('trainings.back')}
        </button>
      </header>
      <div>
        <button className="trainer" onClick={() => onSwitch("trainer")}>
          {t("additionSubtraction")}
        </button>
        <button className="abacus" onClick={() => onSwitch("multi")}>
          {t("multiplicationDivision")}
        </button>
      </div>
    </div>
  )
}

Types.propTypes = {
  onSwitch: PropTypes.func.isRequired,
}

export default Types
